// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalOverallUpdateInfo_modal_container__dB6zQ {
    /* width: 1139px !important; */
    /* height: 775px; */
}

.ModalOverallUpdateInfo_modal_container__dB6zQ .ant-modal-content {
    width: 100%;
    height: 775px;
    padding: 0 !important;
    border-radius: 20px;
    background-color: transparent;
    /* background: url('../../../../statics/update_info_bg.png') no-repeat center / 100% 100%; */
}

.ModalOverallUpdateInfo_modal_container__dB6zQ .ant-modal-body {
    width: 100%;
    height: 100%;
}

.ModalOverallUpdateInfo_main__8dAzX {
    position: relative;
    width: 100%;
    height: 100%;
    /* background-color: #ccc; */
    /* background-color: #fff; */
    /* background: url('../../../../statics/update_info_bg.png') no-repeat center / 100% 100%; */
}


.ModalOverallUpdateInfo_carousel_item__bmmpD,
.ModalOverallUpdateInfo_bg_img__4LD\\+G {
    max-width: 1139px;
    max-height: 775px;
    border-radius: 20px;
}

.ModalOverallUpdateInfo_modal_container__dB6zQ .ant-modal-close {
    color: #f9f9f9;
    transition: background-color 0.5s;
}

.ModalOverallUpdateInfo_modal_container__dB6zQ .ant-modal-close:hover {
    color: #fff;
    background-color: #aaa;
}

.ModalOverallUpdateInfo_modal_container__dB6zQ .ant-modal-close:active {
    color: #fff;
    background-color: #ddd;
}

.ModalOverallUpdateInfo_header__RQbWf {
    width: 100%;
    padding: 60px 0;
    cursor: default;
}

.ModalOverallUpdateInfo_header_title__W-fr2 {
    width: 100%;
    height: 60px;
    text-align: center;
    font-size: 38px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    color: #fff;
}

.ModalOverallUpdateInfo_section__rIzDu {
    width: 100%;
    padding: 0 100px;
    cursor: default;
}

.ModalOverallUpdateInfo_section_new__lzX3W {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 62px;
    height: 26px;
    border: 1px solid #e6e6e6;
    border-radius: 100px;
    font-size: 14px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    color: #17A8B5;
    background-color: #ffffff;
}

.ModalOverallUpdateInfo_section_update__OMdpn {
    font-size: 46px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    color: #FFFFFF;
    padding-top: 10px;
    padding-bottom: 15px;
}

.ModalOverallUpdateInfo_section_update_info__QcJQt {
    font-size: 18px;
    font-family: 'PingFangSCMedium';
    color: #FFFFFF;
    margin-bottom: 32px;
}

/* .content_box {
    width: 100%;
    height: 200px;
} */

.ModalOverallUpdateInfo_update_item__hvJJO {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 293px;
    height: 199px;
    border-radius: 12px;
    background-color: #f9f9f9;
    padding: 30px 40px;
}

.ModalOverallUpdateInfo_item_header__OTkv0 {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 36px;
}

.ModalOverallUpdateInfo_item_model_img__muKMB {
    width: 36px;
    height: 36px;
    /* margin-right: 55px; */
}

.ModalOverallUpdateInfo_item_model_name__xcGqN {
    font-size: 14px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    color: #1C1F25;
}

.ModalOverallUpdateInfo_item_content__\\+AOkd {
    width: 100%;
    height: calc(100% - 36px);
    padding-top: 15px;
    font-size: 14px;
    font-family: 'PingFangSCMedium';
    color: #414648;
}

.ModalOverallUpdateInfo_footer__CNIkN {
    position: absolute;
    left: 50%;
    bottom: 50px;
    transform: translateX(-50%);
}

.ModalOverallUpdateInfo_done_butn_box__iDjz4 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40px;
}

.ModalOverallUpdateInfo_done_butn_arrow_img__LwSoO {
    width: 20px;
    height: 20px;
}

.ModalOverallUpdateInfo_carousel_container__NXK7b {
    height: 100%;
}

.ModalOverallUpdateInfo_carousel_container__NXK7b .slick-slide {
    text-align: center;
}

/* 调整箭头位置 */
.ModalOverallUpdateInfo_carousel_container__NXK7b .slick-prev,
.ModalOverallUpdateInfo_carousel_container__NXK7b .slick-next {
    z-index: 1;
    top: 50%;
    transform: translateY(-50%);
}

.ModalOverallUpdateInfo_carousel_container__NXK7b .slick-prev {
    left: -25px;
}

.ModalOverallUpdateInfo_carousel_container__NXK7b .slick-next {
    right: -25px;
}

.ModalOverallUpdateInfo_carousel_container__NXK7b .slick-dots {
    bottom: 130px;
}

.ModalOverallUpdateInfo_carousel_container__NXK7b .slick-dots li button {
    border-radius: 50%; /* 使按钮变成圆形 */
    width: 10px;        /* 设置新的宽度 */
    height: 10px;       /* 设置新的高度 */
    background-color: #dcdee6;
}

.ModalOverallUpdateInfo_carousel_container__NXK7b .slick-dots .slick-active button {
    background-color: #17a8b5 !important; /* 设置激活状态的颜色，您可以根据需要更改颜色 */
}

.ModalOverallUpdateInfo_carousel_container__NXK7b .slick-dots li,
.ModalOverallUpdateInfo_carousel_container__NXK7b .slick-dots .slick-active {
    width: 10px !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/components/ModalOverallUpdateInfo/index.module.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,6BAA6B;IAC7B,4FAA4F;AAChG;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,4BAA4B;IAC5B,4FAA4F;AAChG;;;AAGA;;IAEI,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,+BAA+B;IAC/B,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,+BAA+B;IAC/B,iBAAiB;IACjB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,cAAc;IACd,mBAAmB;AACvB;;AAEA;;;GAGG;;AAEH;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,WAAW;AACX;;IAEI,UAAU;IACV,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB,EAAE,YAAY;IAChC,WAAW,SAAS,WAAW;IAC/B,YAAY,QAAQ,WAAW;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC,EAAE,0BAA0B;AACpE;;AAEA;;IAEI,sBAAsB;AAC1B","sourcesContent":[".modal_container {\n    /* width: 1139px !important; */\n    /* height: 775px; */\n}\n\n.modal_container :global(.ant-modal-content) {\n    width: 100%;\n    height: 775px;\n    padding: 0 !important;\n    border-radius: 20px;\n    background-color: transparent;\n    /* background: url('../../../../statics/update_info_bg.png') no-repeat center / 100% 100%; */\n}\n\n.modal_container :global(.ant-modal-body) {\n    width: 100%;\n    height: 100%;\n}\n\n.main {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    /* background-color: #ccc; */\n    /* background-color: #fff; */\n    /* background: url('../../../../statics/update_info_bg.png') no-repeat center / 100% 100%; */\n}\n\n\n.carousel_item,\n.bg_img {\n    max-width: 1139px;\n    max-height: 775px;\n    border-radius: 20px;\n}\n\n.modal_container :global(.ant-modal-close) {\n    color: #f9f9f9;\n    transition: background-color 0.5s;\n}\n\n.modal_container :global(.ant-modal-close:hover) {\n    color: #fff;\n    background-color: #aaa;\n}\n\n.modal_container :global(.ant-modal-close:active) {\n    color: #fff;\n    background-color: #ddd;\n}\n\n.header {\n    width: 100%;\n    padding: 60px 0;\n    cursor: default;\n}\n\n.header_title {\n    width: 100%;\n    height: 60px;\n    text-align: center;\n    font-size: 38px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    color: #fff;\n}\n\n.section {\n    width: 100%;\n    padding: 0 100px;\n    cursor: default;\n}\n\n.section_new {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 62px;\n    height: 26px;\n    border: 1px solid #e6e6e6;\n    border-radius: 100px;\n    font-size: 14px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    color: #17A8B5;\n    background-color: #ffffff;\n}\n\n.section_update {\n    font-size: 46px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    color: #FFFFFF;\n    padding-top: 10px;\n    padding-bottom: 15px;\n}\n\n.section_update_info {\n    font-size: 18px;\n    font-family: 'PingFangSCMedium';\n    color: #FFFFFF;\n    margin-bottom: 32px;\n}\n\n/* .content_box {\n    width: 100%;\n    height: 200px;\n} */\n\n.update_item {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    width: 293px;\n    height: 199px;\n    border-radius: 12px;\n    background-color: #f9f9f9;\n    padding: 30px 40px;\n}\n\n.item_header {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    width: 100%;\n    height: 36px;\n}\n\n.item_model_img {\n    width: 36px;\n    height: 36px;\n    /* margin-right: 55px; */\n}\n\n.item_model_name {\n    font-size: 14px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    color: #1C1F25;\n}\n\n.item_content {\n    width: 100%;\n    height: calc(100% - 36px);\n    padding-top: 15px;\n    font-size: 14px;\n    font-family: 'PingFangSCMedium';\n    color: #414648;\n}\n\n.footer {\n    position: absolute;\n    left: 50%;\n    bottom: 50px;\n    transform: translateX(-50%);\n}\n\n.done_butn_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 40px;\n}\n\n.done_butn_arrow_img {\n    width: 20px;\n    height: 20px;\n}\n\n.carousel_container {\n    height: 100%;\n}\n\n.carousel_container :global(.slick-slide) {\n    text-align: center;\n}\n\n/* 调整箭头位置 */\n.carousel_container :global(.slick-prev),\n.carousel_container :global(.slick-next) {\n    z-index: 1;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.carousel_container :global(.slick-prev) {\n    left: -25px;\n}\n\n.carousel_container :global(.slick-next) {\n    right: -25px;\n}\n\n.carousel_container :global(.slick-dots) {\n    bottom: 130px;\n}\n\n.carousel_container :global(.slick-dots li button) {\n    border-radius: 50%; /* 使按钮变成圆形 */\n    width: 10px;        /* 设置新的宽度 */\n    height: 10px;       /* 设置新的高度 */\n    background-color: #dcdee6;\n}\n\n.carousel_container :global(.slick-dots .slick-active button) {\n    background-color: #17a8b5 !important; /* 设置激活状态的颜色，您可以根据需要更改颜色 */\n}\n\n.carousel_container :global(.slick-dots li),\n.carousel_container :global(.slick-dots .slick-active) {\n    width: 10px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_container": `ModalOverallUpdateInfo_modal_container__dB6zQ`,
	"main": `ModalOverallUpdateInfo_main__8dAzX`,
	"carousel_item": `ModalOverallUpdateInfo_carousel_item__bmmpD`,
	"bg_img": `ModalOverallUpdateInfo_bg_img__4LD+G`,
	"header": `ModalOverallUpdateInfo_header__RQbWf`,
	"header_title": `ModalOverallUpdateInfo_header_title__W-fr2`,
	"section": `ModalOverallUpdateInfo_section__rIzDu`,
	"section_new": `ModalOverallUpdateInfo_section_new__lzX3W`,
	"section_update": `ModalOverallUpdateInfo_section_update__OMdpn`,
	"section_update_info": `ModalOverallUpdateInfo_section_update_info__QcJQt`,
	"update_item": `ModalOverallUpdateInfo_update_item__hvJJO`,
	"item_header": `ModalOverallUpdateInfo_item_header__OTkv0`,
	"item_model_img": `ModalOverallUpdateInfo_item_model_img__muKMB`,
	"item_model_name": `ModalOverallUpdateInfo_item_model_name__xcGqN`,
	"item_content": `ModalOverallUpdateInfo_item_content__+AOkd`,
	"footer": `ModalOverallUpdateInfo_footer__CNIkN`,
	"done_butn_box": `ModalOverallUpdateInfo_done_butn_box__iDjz4`,
	"done_butn_arrow_img": `ModalOverallUpdateInfo_done_butn_arrow_img__LwSoO`,
	"carousel_container": `ModalOverallUpdateInfo_carousel_container__NXK7b`
};
export default ___CSS_LOADER_EXPORT___;
